import _styled from "styled-components";
const _excluded = ["className", "style", "children", "placement", "variant", "padding"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { PLACEMENTS, VARIANTS } from '../consts';
import { getMainAxisPlacement, getContainerBodyStyle } from '../helpers';
const Container = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      children,
      placement,
      variant,
      padding = 0
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [{
      position: 'absolute',
      left: 0,
      top: 0,
      margin: 0,
      right: 'auto',
      bottom: 'auto',
      zIndex: theme.zIndex.tooltip
    }, variantSwitch({
      statement: getMainAxisPlacement(placement),
      variants: {
        [PLACEMENTS.LEFT]: {
          padding: `0 ${padding}`
        },
        [PLACEMENTS.RIGHT]: {
          padding: `0 ${padding}`
        },
        [PLACEMENTS.TOP]: {
          padding: `${padding} 0`
        },
        [PLACEMENTS.BOTTOM]: {
          padding: `${padding} 0`
        }
      }
    }), getContainerBodyStyle(variant), style]
  }), children);
});
Container.displayName = 'Container';
Container.propTypes = {
  /** className */
  className: PropTypes.string,
  /** style */
  style: stylePropType,
  /** placement */
  placement: PropTypes.oneOf(Object.values(PLACEMENTS)),
  /** children */
  children: PropTypes.any,
  /** padding */
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** variants */
  variant: PropTypes.oneOf(Object.values(VARIANTS))
};
export default Object.assign(Container, {
  PLACEMENTS,
  VARIANTS
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "Container___StyledDiv",
  componentId: "sc-ynihpb-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Container.js.map